const posts = [
  {
    id: 4,
    slug: 'farmhouse-full-english',
    title: 'Full English - Farmhouse',
    date: 'April 12, 2026',
    blurb: 'A solid, if a little expensive, Full English',
    image: '/images/farmhouse-logo.webp',
    thumbImage: '/images/farmhouse-logo.webp',
    images: ['/images/farmhouse-full-english.jpeg', '/images/farmhouse-bacon.jpeg'],
    rating: 4.5,
    cost: 16.95,
    isNew: true,
    likes: 12,
    tags: ['Full English', 'Harrogate'],
    searchTags: ['sausage', 'bacon', 'eggs', 'beans', 'mushroom', 'tomato', 'toast'],
    location: 'Farmhouse Harrogate',
    links: [
      { label: 'Menu', href: 'https://static1.squarespace.com/static/5cb3af6d9b8fe830d10d3fd0/t/69b9406234afcc06f01532ae/1773748322630/Farmhouse+Main+menu+March+2026-1.pdf' },
      { label: 'About', href: 'https://www.farmhouse.biz/' },
    ],
    body: [
      "I'll start with the music — visiting on a Sunday, I was greeted with \"Manic Monday\". Not the best opening.",
      "The place was largely empty when I arrived, which gave it a slightly flat atmosphere, and I'll admit going solo didn't help on that front. The staff, to their credit, were cheerful and attentive despite the quiet — a nice touch being asked how I wanted my eggs done, which I've always thought separates the places that care from those that don't.",
      { type: "image", src: "/images/farmhouse-full-english.jpeg", alt: "The Farmhouse full English breakfast", float: "right" },
      "On to the breakfast itself. It's a generous plate: two sausages, two eggs with properly runny yolks, a giant mushroom, crispy well-done bacon, tomatoes, and toast — all for £16.95. Steep at first glance, but given the portion size, it's hard to argue. You will not leave hungry. The tomatoes were a highlight, and the kitchen handled my dairy-free request without any fuss.",
      { type: "image", src: "/images/farmhouse-bacon.jpeg", alt: "Crispy bacon at Farmhouse", float: "left" },
      "In and out in half an hour — impressive, though I suspect the empty dining room had something to do with that. I left thoroughly full, in no small part thanks to the generous beans and the makeshift sausage sandwich I fashioned from the toast.",
      "I'd go back. There's a vegan option I've got my eye on for next time — watch this space.",
    ],
  },
  {
    id: 3,
    slug: 'harlow-carr-bettys-full-english',
    likes: 5,
    title: "Full English - Harlow Carr",
    date: 'March 24, 2026',
    blurb: 'A solid full English, though the price point felt a little steep for what\'s on offer.',
    image: '/images/bettys.jpeg',
    thumbImage: '/images/bettys.jpeg',
    images: ['/images/bettys.jpeg', '/images/bettys-full-english-2.jpeg', '/images/bettys-full-english-beans.jpeg'],
    rating: 4,
    cost: 18.50,
    tags: ['Full English', 'Harrogate'],
    searchTags: ['sausage', 'bacon', 'eggs', 'beans', 'rosti', 'mushroom', 'tomato', 'toast'],
    location: 'Harlow Carr',
    links: [
      { label: 'Menu', href: 'https://www.bettys.co.uk/media/pdf/bettys-spring-summer-core-menu-2026.pdf' },
      { label: 'About', href: 'https://www.rhs.org.uk/gardens/harlow-carr' },
    ],
    body: [
      "A solid full English overall, though the price point felt a little steep for what's on offer.",
      { type: "image", src: "/images/bettys-full-english.jpeg", alt: "The full English breakfast", float: "right" },
      "The Yorkshire sausage was enjoyable, if a touch greasier than ideal. The bacon, on the other hand, was cooked to perfection — no notes there. I went for poached eggs over scrambled, and while they lacked that sought-after runny yolk, they were still perfectly pleasant.",
      "The mushroom and tomato did their job reliably, if without much flair — though it's hard to imagine what more you'd ask of them. The rösti bites were a decent enough addition, but I found myself missing a classic hash brown; interestingly, the rösti on the vegan breakfast actually edges ahead in comparison. A generous serving of toast with vegan butter rounded things off nicely, leaving me comfortably satisfied by the end.",
    ],
  },
  {
    id: 2,
    slug: 'rhs-garden-harlow-carr',
    likes: 9,
    title: 'Vegan Breakfast - Harlow Carr',
    date: 'February 26, 2026',
    blurb: 'This was a good vegan breakfast for a solid price.',
    image: '/images/bettys.jpeg',
    thumbImage: '/images/bettys.jpeg',
    images: ['/images/bettys.jpeg'],
    rating: 4,
    cost: 15.50,
    tags: ['Vegan', 'Harrogate'],
    searchTags: ['spinach', 'aubergine', 'beans', 'tomato', 'mushrooms', 'rosti', 'toast'],
    location: 'RHS Garden Harlow Carr',
    links: [
      { label: 'Menu', href: 'https://www.bettys.co.uk/media/pdf/bettys-spring-summer-core-menu-2026.pdf' },
      { label: 'About', href: 'https://www.rhs.org.uk/gardens/harlow-carr' },
    ],
    body: [
      "Vegan alternatives to a Full English can often fall short of their traditional counterparts, and while this was no exception to that rule, it proved to be a respectable offering nonetheless.",
      { type: "image", src: "/images/bettys-breakfast.jpeg", alt: "Eggs Benedict plated up", float: "right" },
      "The spinach — personally my least favoured element — was present in a sensible quantity and delivered an agreeably mild flavour. The smoked paprika aubergine, however, was somewhat lacking; the texture leaned watery and the paprika seasoning failed to make much of an impression. The rösti was undoubtedly the standout component, providing both substance and satisfaction. The toast, served with vegan butter, was well-executed and enjoyable.",
      { type: "image", src: "/images/bettys-toast.jpeg", alt: "Hollandaise sauce being made", float: "left" },
      "The beans deserved particular mention — billed as smoked, this description felt accurate, as they departed meaningfully from a standard baked bean and appeared to use butter beans as their base, which worked well.",
      "On the whole, this was a filling and satisfying meal that did exactly what a Full English should.",
    ],
  },
  {
    id: 1,
    slug: 'tesco-the-coffee-shop',
    likes: 3,
    title: 'The Breakfast - Tesco Coffee Shop',
    date: 'February 23, 2026',
    blurb: 'Simple, satisfying, and cheap. A solid weekday breakfast option.',
    image: '/images/the-coffee-shop.png',
    thumbImage: '/images/the-coffee-shop.png',
    images: ['/images/the-coffee-shop.png', '/images/the-coffee-shop-sign.jpeg', '/images/tesco-sign.jpeg'],
    rating: 3,
    cost: 6.25,
    tags: ['Cheap', 'Harrogate', 'Full English'],
    searchTags: ['sausages', 'bacon', 'egg', 'toast', 'beans', 'hash browns'],
    location: 'Tesco Harrogate',
    links: [
      { label: 'Menu', href: 'https://www.tesco.com/zones/tesco-cafe/brunch-menu?icid=tesco_cafe_hp_browse_menus_breakfast_s1' },
      { label: 'About', href: 'https://www.tesco.com/zones/tesco-cafe?srsltid=AfmBOorDRiqHKmzNye0rh4M8Vc15_gzQE2s1cbggSV8kPEWwsww_gkRO' },
    ],
    body: [
      "At £6.25, this entry-level Full English represents decent value for money. You get a sausage, bacon, two hash browns, beans, an egg, and toast — a respectable spread at the price point.",
      { type: "image", src: "/images/tesco-breakfast.jpg", alt: "The full breakfast spread", float: "right" },
      "The notable absences, however, are mushrooms and tomatoes, which felt like a bit of a let-down. Black pudding was also missing, though that's unlikely to trouble most people.",
      "The highlight was undoubtedly the egg — perfectly cooked with a gloriously runny yolk, ideal for dunking the hash browns into. The bacon was less successful; it arrived on the crispier side, which won't please everyone - it certainly isn't for me. The sausage did its job without distinction, and the beans were exactly what you'd expect: serviceable.",
      { type: "image", src: "/images/tesco-eggs.jpg", alt: "A perfectly runny egg yolk", float: "left" },
      "Worth knowing: a larger version is available for £9.25 — £3 more buys you double the bacon and sausage, an extra egg, and an additional hash brown. On paper, it's the better deal, and likely the smarter order on a return visit.",
      "All told, this is a perfectly acceptable budget breakfast."
    ],
  },
];


export default posts;
